/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const setPrimaryPhoneBodyPhoneNumberMin = 8;
export const setPrimaryPhoneBodyPhoneNumberMax = 32;

export const SetPrimaryPhoneBody = zod.object({
  phoneNumber: zod
    .string()
    .min(setPrimaryPhoneBodyPhoneNumberMin)
    .max(setPrimaryPhoneBodyPhoneNumberMax)
    .describe('The VERIFIED secondary number to promote to primary'),
});

export type SetPrimaryPhoneBody = zod.input<typeof SetPrimaryPhoneBody>;
export type SetPrimaryPhoneBodyOutput = zod.output<typeof SetPrimaryPhoneBody>;
